import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

// Premium Design System
import "./styles/premium.css";

// Layout
import AppShell_Premium from "./components/layout/AppShell_Premium";

// Pages
import LoginPage from "./pages/LoginPage";
import DashboardPage from "./pages/DashboardPage";
import POSPage_Premium from "./pages/POSPage_Premium";
import POSCheckoutPage from "./pages/POSCheckoutPage";
import ProductsPage from "./pages/ProductsPage";
import StockPage from "./pages/StockPage";
import StockOverviewPage from "./pages/StockOverviewPage";
import SalesPage from "./pages/SalesPage";
import ReturnsPage from "./pages/ReturnsPage";
import ServiceOrdersPage from "./pages/ServiceOrdersPage";
import ExpensesPage from "./pages/ExpensesPage";
import CustomersPage from "./pages/CustomersPage";
import EmployeesPage from "./pages/EmployeesPage";
import CashFlowPage from "./pages/CashFlowPage";
import ReportsPage from "./pages/ReportsPage";
import MaterialPurchasesPage from "./pages/MaterialPurchasesPage";

function ProtectedRoute({ children }) {
  const token = useSelector((state) => state.auth.token);
  return token ? children : <Navigate to="/login" replace />;
}

function App() {
  return (
    <BrowserRouter
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}
    >
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        
        <Route element={<ProtectedRoute><AppShell_Premium /></ProtectedRoute>}>
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/pos" element={<POSPage_Premium />} />
          <Route path="/pos/checkout" element={<POSCheckoutPage />} />
          <Route path="/products" element={<ProductsPage />} />
          <Route path="/stock" element={<StockPage />} />
          <Route path="/stock/overview" element={<StockOverviewPage />} />
          <Route path="/sales" element={<SalesPage />} />
          <Route path="/returns" element={<ReturnsPage />} />
          <Route path="/service-orders" element={<ServiceOrdersPage />} />
          <Route path="/expenses" element={<ExpensesPage />} />
          <Route path="/material-purchases" element={<MaterialPurchasesPage />} />
          <Route path="/customers" element={<CustomersPage />} />
          <Route path="/employees" element={<EmployeesPage />} />
          <Route path="/cashflow" element={<CashFlowPage />} />
          <Route path="/reports" element={<ReportsPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
